import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const excludedCountries = [];

const buttonVariations = [
  {
    label: <>OKX Crypto Rewards</>,
    title: <>Earn $500 in BTC + 3.5% APY on RLUSD</>,
    content: <>
    New to OKX? Let the rewards stack.
    <ol>
        <li>Verify your account, get $10 in BTC.</li>
        <li>Deposit $100, get $50 in BTC</li>
        <li>Complete additional trade tasks, get up to $500 in BTC.</li>
        <li>Hold RLUSD and USDG on OKX. Earn 3.5% APY</li>
    </ol>
    </>,
    href: "https://api.xrpscan.com/api/v1/campaign/okxbutton1",
  },
]

let variantIndex = 0;
try {
  variantIndex = Math.floor(Math.random() * buttonVariations.length);
} catch (error) {}
const buttonVariation = buttonVariations[variantIndex];

const OKXButton = (props) => {
  const { location } = props;
  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        {buttonVariation.title}
        <span className="small ml-1"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>{buttonVariation.content}</Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href={buttonVariation.href}
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >{buttonVariation.label}</Button>
        </OverlayTrigger>
    </span>
  )
}

OKXButton.propTypes = {
  location: PropTypes.string.isRequired,
}

export default OKXButton;